import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { LoginService } from '../login/login.service';
@Injectable({
  providedIn: 'root'
})
export class EmailService {
  private limitReachEndpoint = `${environment.builderURL}send_limit_reached_email/`;

  constructor(private http: HttpClient,private loginService: LoginService) {}

  sendProjectNearEmail(current: number, limit: number) {
    const emailData = {
      email_type: 'project_near_limit',
      email: this.user?.email,
      username: this.user?.username,
      projects_count: current,
      projects_limit: limit
    };

    return this.http.post(
      this.limitReachEndpoint,
      emailData
    );
  }

  sendProjectLimitEmail(current: number, limit: number) {
    const emailData = {
      email_type: 'project_limit_reached',
      email: this.user?.email,
      username: this.user?.username,
      projects_count: current,
      projects_limit: limit
    };

    return this.http.post(
      this.limitReachEndpoint,
      emailData
    );
  }

  
  private get user() {
    return this.loginService.getCurrentUser();
  }

}
